"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupCustomInspect = void 0;
var setupCustomInspect = function (obj) {
    // No custom inspect for browsers
};
exports.setupCustomInspect = setupCustomInspect;
